<div class="distributor-management">
  <header>
    <div class="header-left">
      <h2>Vendor Management</h2>
      <div *ngIf="accountName" class="account-name">{{accountName}}</div>
    </div>
    <div class="header-right">
      <div class="close" (click)="close()"></div>
    </div>
  </header>

  <div *ngIf="errors.length > 0" class="error-bar">
    <div *ngFor="let error of errors" class="error">{{error}}</div>
  </div>

  <div *ngIf="loading" class="loading">Loading . . .</div>
  <div *ngIf="loadError" class="error-bar"><div class="error">{{loadError}}</div></div>

  <section *ngIf="!loading && !loadError" class="body">

    <div class="distributor-table">
      <div class="table-header">
        <div class="col-distributor">Vendor</div>
        <div class="col-price">Price</div>
        <div class="col-qty">Case Qty</div>
        <div class="col-barcode">Barcode</div>
        <div class="col-remove"></div>
      </div>

      <div *ngIf="rows.length === 0" class="empty-state">
        No vendors yet. Add the first one below.
      </div>

      <div *ngFor="let row of rows" class="table-row" [class.removed]="row.removed" [class.new-row]="row.isNew">
        <div class="col-distributor">
          <ng-container *ngIf="!row.editingDistributor">
            <!-- Existing rows link to the full Vendor Product View (where the
                 Vendor field changes the distributor); unsaved new rows reopen
                 the inline picker. -->
            <span class="distributor-name"
                  [class.linked]="!row.isNew && canOpenVendorProduct"
                  (click)="row.isNew ? editDistributor(row) : openVendorProduct(row)"
                  [title]="row.isNew ? 'Change vendor' : (canOpenVendorProduct ? 'Open vendor product' : '')">{{row.distributorName || 'Select vendor . . .'}}</span>
            <span *ngIf="row.isNew" class="tag new">New</span>
            <span *ngIf="row.removed" class="tag removed-tag">Will be removed</span>
            <span *ngIf="row.otherItemCount > 0" class="tag other-items"
                  title="This vendor product also supplies other retail items">+{{row.otherItemCount}} other item{{row.otherItemCount > 1 ? 's' : ''}}</span>
          </ng-container>
          <ng-container *ngIf="row.editingDistributor">
            <input type="text" class="distributor-search" placeholder="Search vendors . . ."
                   [(ngModel)]="row.searchText" (ngModelChange)="searchDistributors(row)"
                   (blur)="row.results.length === 0 ? cancelDistributorEdit(row) : null" />
            <div *ngIf="row.results.length > 0" class="distributor-results">
              <div *ngFor="let vendor of row.results" class="distributor-result" (mousedown)="selectDistributor(row, vendor)">
                {{vendor.name}}
              </div>
            </div>
          </ng-container>
        </div>
        <div class="col-price">
          <div class="cell-input" [class.invalid]="rowInvalid(row) && (row.price === null || row.price === undefined)">
            <span class="currency-symbol">$</span>
            <input type="number" step="0.01" min="0" [(ngModel)]="row.price" [disabled]="row.removed" placeholder="0.00" />
          </div>
        </div>
        <div class="col-qty">
          <div class="cell-input" [class.invalid]="rowInvalid(row) && !(row.caseQty > 0)">
            <input type="number" step="1" min="1" [(ngModel)]="row.caseQty" [disabled]="row.removed" placeholder="1" />
          </div>
        </div>
        <div class="col-barcode">
          <div class="cell-input">
            <input type="text" [(ngModel)]="row.barcode" [disabled]="row.removed" placeholder="Barcode" />
          </div>
        </div>
        <div class="col-remove">
          <div class="remove-btn" [class.undo]="row.removed" (click)="removeRow(row)"
               [title]="row.removed ? 'Keep this vendor' : 'Remove this vendor'">
            <ng-container *ngIf="!row.removed">&#x2715;</ng-container>
            <ng-container *ngIf="row.removed">Undo</ng-container>
          </div>
        </div>
      </div>

      <div class="add-row">
        <div class="add-distributor" (click)="addRow()">+ Add Vendor</div>
      </div>
    </div>

  </section>

  <footer *ngIf="!loading && !loadError">
    <button class="button" [disabled]="saving || !hasChanges()" (click)="save()">
      {{saving ? 'Saving . . .' : 'Save'}}
    </button>
  </footer>
</div>
